import {
  Box,
  MenuItem,
  Typography,
  Select,
  InputAdornment,
  IconButton,
} from "@mui/material"

import ClearIcon from "@mui/icons-material/Clear"

import { FilterIcon } from "./Atom"
import { useDispatch, useSelector } from "react-redux"
import { setMetricOpportunityColumnFilterSelectValues } from "../../../redux/slices/metricSlice"
import { colors } from "../../../../styles/commonStyles"

const MetricOpportunityColumnFilter = (props: any) => {
  const dispatch = useDispatch()

  const opportunityTableDataFiltered = useSelector((state: any) => {
    return state.metric.metricOpportunityTableDataFiltered
  })

  const opportunityTableData = useSelector((state: any) => {
    return state.metric.metricOpportunityTableData
  })

  const selectedMetricOpportunityTab = useSelector((state: any) => {
    return state.metric.selectedMetricOpportunityTab
  })

  const selectValues = useSelector((state: any) => {
    return state.metric.metricOpportunityColumnFilterSelectValues
  })

  const { header, column, filterColors } = props

  const headerIndex = header?.index

  async function handleFilterColors(filterColor: any, index: any) {
    if (selectValues[index] !== "") {
      await handleClear(index)
    }

    handleApply(filterColor, index)
  }

  const handleApply = async (filterColor: any, index: any) => {
    dispatch(
      setMetricOpportunityColumnFilterSelectValues({ filterColor, index }),
    )

    filterColors(
      selectedMetricOpportunityTab,
      opportunityTableData,
      opportunityTableDataFiltered,
      filterColor,
      column?.id,
      selectValues,
      index,
    )
  }

  const handleClear = async (index: any) => {
    dispatch(
      setMetricOpportunityColumnFilterSelectValues({
        filterColor: "",
        index: index,
      }),
    )

    filterColors(
      selectedMetricOpportunityTab,
      opportunityTableData,
      opportunityTableDataFiltered,
      "all",
      column?.id,
      selectValues,
      index,
    )
  }

  return (
    <Box>
      <Select
        displayEmpty
        name="select1"
        value={selectValues[headerIndex]}
        onChange={(e) => handleFilterColors(e.target.value, headerIndex)}
        sx={{
          height: "32px",
          width: "100%",
          // padding: "0px 10px",
          borderRadius: "0",
          position: "absolute",
          bottom: 0,
          left: 0,
          color:
            // selectValues[headerIndex] === "red"
            //   ? "#F25854"
            //   : selectValues[headerIndex] === "green"
            //   ? "#40B2A0"
            //   : selectValues[headerIndex] === "yellow"
            //   ? "#EBAD07"
            //   : "#FFFFFF",
            "#FFFFFF",
          backgroundColor:
            selectValues[headerIndex] === "red"
              ? "#f59390"
              : selectValues[headerIndex] === "green"
              ? "#78b3ad"
              : selectValues[headerIndex] === "yellow"
              ? "#ebce81"
              : "#FFFFFF",
          "& .css-hfutr2-MuiSvgIcon-root-MuiSelect-icon": {
            display: "none",
          },
          "& .css-bpeome-MuiSvgIcon-root-MuiSelect-icon": {
            display: "none",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
          "& .css-1woudn8-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root":
            {
              borderRadius: "none !important",
            },
        }}
        startAdornment={
          <InputAdornment
            position="start"
            sx={{
              fill:
                // selectValues[headerIndex] === "red"
                //   ? "#F25854"
                //   : selectValues[headerIndex] === "green"
                //   ? "#40B2A0"
                //   : selectValues[headerIndex] === "yellow"
                //   ? "#EBAD07"
                //   : "",
                selectValues[headerIndex] === "red"
                  ? "#FFFFFF"
                  : selectValues[headerIndex] === "green"
                  ? "#FFFFFF"
                  : selectValues[headerIndex] === "yellow"
                  ? "#FFFFFF"
                  : "",
            }}
          >
            <FilterIcon />
          </InputAdornment>
        }
        endAdornment={
          selectValues[headerIndex] && (
            <IconButton onClick={() => handleClear(headerIndex)} size="small">
              <ClearIcon
                sx={{
                  color:
                    // selectValues[headerIndex] === "red"
                    //   ? "#F25854"
                    //   : selectValues[headerIndex] === "green"
                    //   ? "#40B2A0"
                    //   : selectValues[headerIndex] === "yellow"
                    //   ? "#EBAD07"
                    //   : "#FFFFFF",
                    "#FFFFFF",
                }}
              />
            </IconButton>
          )
        }
        inputProps={{ IconComponent: () => null }}
        disableUnderline
        renderValue={(value) => {
          if (value === "") {
            return (
              <Typography
                sx={{
                  color: "#707070",
                  fontSize: "14px",
                }}
              >
                No Filter
              </Typography>
            )
          }
          return value?.toUpperCase()
        }}
        MenuProps={{
          sx: {
            minHeight: "300px",
          },
        }}
      >
        <MenuItem
          value=""
          disabled
          sx={{
            borderBottom: "2px solid #E4E4E4",
            color: "#000",
          }}
        >
          Filter By
        </MenuItem>
        <MenuItem
          value={"red"}
          sx={{
            backgroundColor: colors.primaryRed,
            "&:hover": {
              backgroundColor: "none",
            },
            margin: "5px 10px",
            padding: "10px 10px",
            color: "#FFFFFF",
          }}
        >
          Red
        </MenuItem>
        <MenuItem
          value={"green"}
          sx={{
            backgroundColor: colors.primaryGreen,
            "&:hover": {
              backgroundColor: "none",
            },
            margin: "5px 10px",
            padding: "10px 10px",
            color: "#FFFFFF",
          }}
        >
          Green
        </MenuItem>
        <MenuItem
          value={"yellow"}
          sx={{
            backgroundColor: colors.primaryYellow,
            "&:hover": {
              backgroundColor: "none",
            },
            margin: "5px 10px",
            padding: "10px 10px",
            color: "#000000",
          }}
        >
          Yellow
        </MenuItem>
      </Select>
    </Box>
  )
}

export default MetricOpportunityColumnFilter
